import { render, staticRenderFns } from "./CommunityHealthInfo.vue?vue&type=template&id=da02a6a2"
import script from "./CommunityHealthInfo.vue?vue&type=script&lang=js"
export * from "./CommunityHealthInfo.vue?vue&type=script&lang=js"
import style0 from "./CommunityHealthInfo.vue?vue&type=style&index=0&id=da02a6a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports